(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Add to cart functionality
document.addEventListener('click', function(event) {
  if (event.target.matches('[data-add-to-cart]')) {
    const button = event.target;
    const variantId = button.dataset.variantId;

    // Disable button and show loading state
    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Adding...';

    // Add to cart via Shopify AJAX API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      // Success - update cart count and show feedback
      const customEvent = new CustomEvent('cart:updated', {
        detail: { item_count: data.item_count || 0 }
      });
      document.dispatchEvent(customEvent);

      button.textContent = 'Added!';
      button.classList.remove('bg-primary', 'hover:bg-red-700');
      button.classList.add('bg-green-600');

      // Reset button after 2 seconds
      setTimeout(() => {
        button.textContent = originalText;
        button.classList.remove('bg-green-600');
        button.classList.add('bg-primary', 'hover:bg-red-700');
        button.disabled = false;
      }, 2000);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      button.textContent = 'Error - Try Again';
      button.disabled = false;

      // Reset button after 2 seconds
      setTimeout(() => {
        button.textContent = originalText;
      }, 2000);
    });
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-bar"] && !Shopify.designMode) return;
  try {
    (function() {
  "use strict";

  // Shopify money formatting helper
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = (format || this.money_format);

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number/100.0).toFixed(precision);

      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const cents = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value).replace(/^Rp[\s\u00a0]+/i, 'Rp');
  };

  class PredictiveSearch {
    constructor(component) {
      this.component = component;
      this.input = component.querySelector('[data-search-input]');
      this.dropdown = component.querySelector('[data-search-dropdown]');
      this.resultsContainer = component.querySelector('[data-search-results]');
      this.loadingState = component.querySelector('[data-search-loading]');
      this.emptyState = component.querySelector('[data-search-empty]');

      this.debounceTimer = null;
      this.currentRequest = null;
      this.selectedIndex = -1;

      // Input events
      this.input.addEventListener('input', (e) => this.handleInput(e));
      this.input.addEventListener('focus', (e) => this.handleFocus(e));
      this.input.addEventListener('keydown', (e) => this.handleKeydown(e));

      // Close on outside click
      document.addEventListener('click', (e) => {
        if (!this.component.contains(e.target)) {
          this.closeDropdown();
        }
      });

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeDropdown();
        }
      });

      // Reposition on scroll and resize
      window.addEventListener('scroll', () => {
        if (!this.dropdown.classList.contains('hidden')) {
          this.repositionDropdown();
        }
      });

      window.addEventListener('resize', () => {
        if (!this.dropdown.classList.contains('hidden')) {
          this.repositionDropdown();
        }
      });
    }

    repositionDropdown() {
      const rect = this.component.getBoundingClientRect();
      const formRect = this.component.querySelector('form').getBoundingClientRect();

      this.dropdown.style.top = `${formRect.bottom + 8}px`;
      this.dropdown.style.left = `${rect.left}px`;
      this.dropdown.style.width = `${rect.width}px`;
    }

    handleInput(e) {
      const query = e.target.value.trim();

      // Clear debounce timer
      clearTimeout(this.debounceTimer);

      // Cancel previous request
      if (this.currentRequest) {
        this.currentRequest.abort();
      }

      // Hide dropdown if query is too short
      if (query.length < 2) {
        this.closeDropdown();
        return;
      }

      // Show loading state
      this.showLoading();

      // Debounce search (300ms)
      this.debounceTimer = setTimeout(() => {
        this.performSearch(query);
      }, 300);
    }

    handleFocus(e) {
      const query = e.target.value.trim();
      if (query.length >= 2 && this.resultsContainer.children.length > 0) {
        this.openDropdown();
      }
    }

    handleKeydown(e) {
      if (!this.dropdown.classList.contains('hidden')) {
        const items = this.resultsContainer.querySelectorAll('[data-search-result-item]');

        switch(e.key) {
          case 'ArrowDown':
            e.preventDefault();
            this.selectedIndex = Math.min(this.selectedIndex + 1, items.length - 1);
            this.updateSelection(items);
            break;
          case 'ArrowUp':
            e.preventDefault();
            this.selectedIndex = Math.max(this.selectedIndex - 1, -1);
            this.updateSelection(items);
            break;
          case 'Enter':
            if (this.selectedIndex >= 0 && items[this.selectedIndex]) {
              e.preventDefault();
              items[this.selectedIndex].click();
            }
            break;
        }
      }
    }

    updateSelection(items) {
      items.forEach((item, index) => {
        if (index === this.selectedIndex) {
          item.classList.add('bg-surface-light');
        } else {
          item.classList.remove('bg-surface-light');
        }
      });

      // Scroll selected item into view
      if (this.selectedIndex >= 0 && items[this.selectedIndex]) {
        items[this.selectedIndex].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }

    async performSearch(query) {
      // Create abort controller for this request
      const controller = new AbortController();
      this.currentRequest = controller;

      try {
        // Build URL with proper parameter encoding
        const params = new URLSearchParams({
          'q': query,
          'resources[type]': 'product,collection',
          'resources[options][product][limit]': '6',
          'resources[options][collection][limit]': '3'
        });

        const response = await fetch(
          `/search/suggest.json?${params.toString()}`,
          { signal: controller.signal }
        );

        if (!response.ok) throw new Error('Search failed');

        const data = await response.json();
        const collections = data.resources.results.collections || [];
        const products = data.resources.results.products || [];
        this.renderResults(collections, products, query);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Search error:', error);
          this.closeDropdown();
        }
      }
    }

    renderResults(collections, products, query) {
      this.hideLoading();

      if (collections.length === 0 && products.length === 0) {
        this.showEmptyState();
        return;
      }

      this.hideEmptyState();
      this.selectedIndex = -1;

      let html = '';

      // Render collections first (as regions)
      if (collections.length > 0) {
        const collectionsHtml = collections.map(collection => {
          // Collection image is automatically pulled if set in Shopify admin
          const imageUrl = collection.image ? collection.image : '';
          const title = collection.title.replace(/"/g, '&quot;');

          const imageHtml = imageUrl
            ? `<img src="${imageUrl}" alt="${title}" class="w-full h-full object-cover" loading="lazy" />`
            : '<div class="w-full h-full flex items-center justify-center"><svg class="h-8 w-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" /></svg></div>';

          return `<a href="${collection.url}" class="flex items-center gap-4 p-4 hover:bg-surface-light transition-colors border-b border-gray-100" data-search-result-item>
            <div class="flex-shrink-0 w-16 h-16 bg-blue-50 rounded-lg overflow-hidden">${imageHtml}</div>
            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-2">
                <svg class="w-4 h-4 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
                <h3 class="text-sm font-heading font-bold truncate">${collection.title}</h3>
              </div>
              <p class="text-xs text-paragraph mt-1">Region</p>
            </div>
            <div class="flex-shrink-0">
              <svg class="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" /></svg>
            </div>
          </a>`;
        }).join('');

        html += collectionsHtml;
      }

      // Render products
      if (products.length > 0) {
        const productsHtml = products.map(product => {
          const imageUrl = product.image ? product.image : '';
          const saleVariant = Array.isArray(product.variants)
            ? product.variants.find(variant => Number.parseFloat(variant.compare_at_price || 0) > Number.parseFloat(variant.price || 0))
            : null;
          const displayPrice = saleVariant ? saleVariant.price : (product.price_min || product.price);
          const compareAtPrice = saleVariant
            ? saleVariant.compare_at_price
            : (product.compare_at_price_min || product.compare_at_price);
          const priceAmount = Number.parseFloat(displayPrice || 0);
          const compareAtAmount = Number.parseFloat(compareAtPrice || 0);
          const isOnSale = compareAtAmount > priceAmount;
          const price = Shopify.formatMoney(displayPrice, Shopify.money_format);
          const compareAtPriceFormatted = isOnSale
            ? Shopify.formatMoney(compareAtPrice, Shopify.money_format)
            : '';
          const discountPercent = isOnSale
            ? Math.round(((compareAtAmount - priceAmount) * 100) / compareAtAmount)
            : 0;
          const title = product.title.replace(/"/g, '&quot;');

          const imageHtml = imageUrl
            ? `<img src="${imageUrl}" alt="${title}" class="w-full h-full object-cover" loading="lazy" />`
            : '<div class="w-full h-full flex items-center justify-center"><svg class="h-8 w-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg></div>';

          const priceHtml = isOnSale
            ? `<div class="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1">
                <span class="inline-flex items-center rounded-full border border-primary px-1.5 py-0.5 text-[10px] font-bold leading-none text-primary">${discountPercent}%</span>
                <span class="text-xs text-primary font-bold"><span class="font-normal text-paragraph">from</span> ${price}</span>
                <span class="text-xs text-paragraph line-through">${compareAtPriceFormatted}</span>
              </div>`
            : `<p class="text-xs text-primary font-bold mt-1"><span class="font-normal text-paragraph">from</span> ${price}</p>`;

          return `<a href="${product.url}" class="flex items-center gap-4 p-4 hover:bg-surface-light transition-colors border-b border-gray-100 last:border-b-0" data-search-result-item>
            <div class="flex-shrink-0 w-16 h-16 bg-gray-100 rounded-lg overflow-hidden">${imageHtml}</div>
            <div class="flex-1 min-w-0">
              <h3 class="text-sm font-heading font-bold truncate">${product.title}</h3>
              ${priceHtml}
            </div>
            <div class="flex-shrink-0">
              <svg class="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" /></svg>
            </div>
          </a>`;
        }).join('');

        html += productsHtml;
      }

      this.resultsContainer.innerHTML = html;

      // Add "View All Results" link at the bottom
      const viewAllLink = document.createElement('a');
      viewAllLink.href = `/search?q=${encodeURIComponent(query)}`;
      viewAllLink.className = 'block p-4 text-center text-sm font-medium text-primary hover:bg-surface-light transition-colors border-t-2 border-gray-200';
      viewAllLink.textContent = `View all results for "${query}"`;
      this.resultsContainer.appendChild(viewAllLink);

      this.openDropdown();
    }

    showLoading() {
      this.loadingState.classList.remove('hidden');
      this.resultsContainer.classList.add('hidden');
      this.emptyState.classList.add('hidden');
      this.openDropdown();
    }

    hideLoading() {
      this.loadingState.classList.add('hidden');
      this.resultsContainer.classList.remove('hidden');
    }

    showEmptyState() {
      this.emptyState.classList.remove('hidden');
      this.resultsContainer.classList.add('hidden');
      this.openDropdown();
    }

    hideEmptyState() {
      this.emptyState.classList.add('hidden');
    }

    openDropdown() {
      // Calculate position for fixed dropdown
      const rect = this.component.getBoundingClientRect();
      const formRect = this.component.querySelector('form').getBoundingClientRect();

      this.dropdown.style.top = `${formRect.bottom + 8}px`;
      this.dropdown.style.left = `${rect.left}px`;
      this.dropdown.style.width = `${rect.width}px`;
      this.dropdown.style.right = 'auto';

      this.dropdown.classList.remove('hidden');
    }

    closeDropdown() {
      this.dropdown.classList.add('hidden');
      this.selectedIndex = -1;
    }
  }

  // Initialize all search components
  document.addEventListener('DOMContentLoaded', () => {
    const components = document.querySelectorAll('[data-search-component]');
    components.forEach(component => new PredictiveSearch(component));
  });
})();
  } catch(e) { console.error(e); }
})();

})();
